import Vue from "vue";
import Formival from "formival";
import InputField from "./form-controls/InputField.vue";
import DatepickerField from "./form-controls/DatepickerField.vue";
import SelectField from "./form-controls/SelectField.vue";
import TextareaField from "./form-controls/TextareaField.vue";
import FieldWrapper from "./form-controls/FieldWrapper.vue";
import TemplateField from "./form-controls/TemplateField.vue";
import RedirectButton from "./components/RedirectButton.vue";
import RecaptchaField from "./form-controls/RecaptchaField.vue";
import SubmitButton from "./form-controls/SubmitButton.vue";
import SectionTitle from "./form-controls/SectionTitle.vue";
import AttachmentsField from "./form-controls/AttachmentsField.vue";
import HiddenField from "./form-controls/HiddenField.vue";

Vue.use(Formival);

const types = [
  {
    name: "input",
    component: InputField,
    wrappers: ["field-wrapper"]
  },
  {
    name: "datepicker",
    component: DatepickerField,
    wrappers: ["field-wrapper"]
  },
  {
    name: "select",
    component: SelectField,
    wrappers: ["field-wrapper"]
  },
  {
    name: "textarea",
    component: TextareaField,
    wrappers: ["field-wrapper"]
  },
  {
    name: "template",
    component: TemplateField
  },
  {
    name: "paragraph",
    component: TemplateField
  },
  {
    name: "redirect",
    component: RedirectButton
  },
  {
    name: "captcha",
    component: RecaptchaField,
    wrappers: ["field-wrapper"]
  },
  {
    name: "submit",
    component: SubmitButton
  },
  {
    name: "sectionTitle",
    component: SectionTitle
  },
  {
    name: "attachments",
    component: AttachmentsField,
    wrappers: ["field-wrapper"],
  },
  {
    name: "hidden",
    component: HiddenField,
  },
];

const wrappers = [
  {
    name: "field-wrapper",
    component: FieldWrapper
  }
];

const validationMessages = {
  required: "{{field.templateOptions && field.templateOptions.label}} is required",
  email: "{{value}} is not a valid email address"
};

const formival = new Formival({
  types,
  wrappers,
  validationMessages
});

export default formival;
